import { useQuery } from '@tanstack/react-query';
import api from '../../../lib/api';
import { JiraProject } from '../types/outboundIntegration/jira';

export type IntegrationType = {
  id: string;
  name: string;
  integrationId: string;
  type: string;
};

export interface LinearTeam {
  id: string;
  name: string;
  key?: string;
}

export interface LinearProject {
  id: string;
  name: string;
}

export function useGetOutboundIntegrations() {
  return useQuery({
    queryKey: ['getOutboundIntegrations'],
    queryFn: async () => {
      const res = await api.get(`/api/core/tenant/outbound-integrations`);
      return res.data.data as IntegrationType[];
    },
  });
}

export function useListJiraProjects(integrationId?: string, enabled = true) {
  return useQuery({
    queryKey: ['listJiraProjects', integrationId],
    queryFn: async () => {
      if (!integrationId) {
        return [];
      }
      const response = await api.post(
        `/api/core/tenant/outbound-integrations/jira/projects`,
        {
          integrationId,
        },
      );
      return response.data.data as JiraProject[];
    },
    enabled: enabled && !!integrationId,
  });
}

export function useLinearTeams(integrationId?: string, enabled = true) {
  return useQuery({
    queryKey: ['linearTeams', integrationId],
    queryFn: async () => {
      if (!integrationId) {
        return [];
      }
      const response = await api.post<{ data: LinearTeam[] }>(
        `/api/core/tenant/outbound-integrations/linear/teams`,
        { integrationId },
      );
      return response.data.data;
    },
    enabled: enabled && !!integrationId,
  });
}

export function useLinearProjects(integrationId?: string, teamId?: string) {
  return useQuery({
    queryKey: ['linearProjects', integrationId, teamId],
    queryFn: async () => {
      if (!integrationId || !teamId) {
        return [];
      }
      const response = await api.post<{ data: LinearProject[] }>(
        `/api/core/tenant/outbound-integrations/linear/projects`,
        { integrationId, teamId },
      );
      return response.data.data;
    },
    enabled: !!integrationId && !!teamId,
  });
}
